<template>
  <v-card-text  @scroll="onScroll">
    <v-layout row>
      <v-flex xs12 class="draggable-wrap small">
        <div class="draggable-area destination small" >
          <v-list v-for="(item, index) in displaydedBeacons" :key="index" class="draggable-item small">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>bluetooth</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  <strong>{{ item.name }}</strong>
                </v-list-tile-title>
              </v-list-tile-content>
              <beacon-setting :items="item" :actions="actions"></beacon-setting>
            </v-list-tile>
          </v-list>
        </div>
      </v-flex>
    </v-layout>
  </v-card-text>
</template>

<script>
import BeaconSetting from "./BeaconSetting";

export default {
  props: ['items', 'actions'],
  data() {
    return {
      startIndex: 0,
      endIndex: 50,
      displaydedBeacons: [],
    };
  },
  components: {
    BeaconSetting
  },
  methods: {
    updateDisplaydedBeacons() {
      this.displaydedBeacons = this.items.slice(this.startIndex, this.endIndex);
    },
    onScroll(event) {

      const container = event.target;
      const { scrollTop, scrollHeight, clientHeight } = container;
      if (scrollTop >= (2 / 3) * (scrollHeight - clientHeight)) {
        this.endIndex += 50;
        this.updateDisplaydedBeacons();
      }
    }
  },
  mounted() {
    this.updateDisplaydedBeacons();
  }
};
</script>

<style>
</style>
